import { Tooltip } from 'antd'
import { useAccessibility } from 'context/hooks/useAccessibility'
import { useFamily } from 'context/hooks/useFamily'
import useQuery from 'context/hooks/useQuery'
import React from 'react'
import { getOverlayCustomTooltip } from 'utils/utils'
import { Device } from '../Device'
import './styles.scss'

interface DataSourcesTabsCardProps {
  titles: string[]
  children: React.ReactNode
  noticeOfInconsistencies?: React.ReactNode
  currentBase: number
  setCurrentBase?: (value: number) => void
}

function DataSourcesTabsCard({
  titles,
  children,
  noticeOfInconsistencies = <></>,
  currentBase,
  setCurrentBase,
}: DataSourcesTabsCardProps) {
  const device = Device.useDevice()
  const devicePrefix = device.prefix()

  const { basesWithoutData, basesWithTimeout } = useFamily()
  const { basesNameIdsPerName } = useQuery()
  const { contrastIsSelected } = useAccessibility()

  return (
    <div className={`container-cardTabs ${devicePrefix ?? 'undefined'}`}>
      <header className={`${devicePrefix ?? 'undefined'}`}>
        <h1>Bases</h1>
        <div className="container-cardTabs__bases">
          {titles.map((title, index) => {
            return basesWithoutData.includes(basesNameIdsPerName[title]) ? (
              <Tooltip
                title={
                  basesWithTimeout.includes(basesNameIdsPerName[title])
                    ? 'Base indisponível no momento'
                    : 'A família não está nesta base'
                }
                overlayStyle={getOverlayCustomTooltip(contrastIsSelected)}
              >
                <button
                  key={title}
                  className={index === currentBase ? 'active' : ''}
                  onClick={() => {
                    setCurrentBase?.(index)
                  }}
                  disabled
                >
                  {title}
                </button>
              </Tooltip>
            ) : (
              <button
                key={title}
                className={index === currentBase ? 'active' : ''}
                onClick={() => {
                  setCurrentBase?.(index)
                }}
              >
                {title}
              </button>
            )
          })}
        </div>
      </header>
      {noticeOfInconsistencies}
      <div className="container-list">
        {React.Children.map(children, (child, index) => {
          if (index === currentBase) {
            return child
          }
        })}
      </div>
    </div>
  )
}

export default DataSourcesTabsCard
